import useTranslation from 'next-translate/useTranslation';
import type { FC } from 'react';

import { Translate } from '@core/constant';

import { ButtonSubmit } from './ButtonSubmit';
import { SubmitButtonCustomProps } from './interface-button';

export const SendMeInstructionsButton: FC<SubmitButtonCustomProps> = ({
  ...props
}: SubmitButtonCustomProps): JSX.Element => {
  const { t: tButton } = useTranslation(Translate.common.BUTTON);

  return <ButtonSubmit {...props}>{tButton('sendMeInstructions.title')}</ButtonSubmit>;
};
